import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import type { ZeitAccountStatuses } from '../../../../main/types/adPartnerTypes';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { GetSANAdPartnerZeitStatusPayload } from '../AdPartner.types';

const GetSanAdAccountZeitStatus = new ReduxAsyncAction<
  'GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS',
  GetSANAdPartnerZeitStatusPayload,
  ZeitAccountStatuses
>('GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS');

GetSanAdAccountZeitStatus.registerRequest(({ ad_network, lookback_days = 7 }) => {
  const params = ad_network ? { params: { ad_network, lookback_days } } : {};
  return dash_api.get(`/v1/zeit-query/ad-account-status/`, params).then((res) => {
    return res.data;
  });
});

export const GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS = GetSanAdAccountZeitStatus.actionNamespaceConstants;

export const getSanAdAccountZeitStatus = GetSanAdAccountZeitStatus.request;

export type GetSanAdAccountZeitStatusAction = Action<typeof GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS.response> & {
  data: {
    [ad_partner: string]: ZeitAccountStatuses;
  };
};
